//引入React核心库
import React from "react";
//引入ReactDOM
import ReactDOM from "react-dom";
//引入App组件
import App from "./App";
//引入Router组件
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";




//渲染App
ReactDOM.render(
    <BrowserRouter>
        <AuthProvider>
            <App/>
        </AuthProvider>
    </BrowserRouter>,
    document.getElementById('root')
    )

